module.exports = __webpack_public_path__ + "static/img/icon-05.26155ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/how-it-works/icon-05.png
// module id = I8jB
// module chunks = 1